<template>
  <v-dialog
    v-model="showLocal"
    max-width="630"
    persistent
  >
    <v-card>
      <v-card-title
        class="pb-0"
      >
        <v-spacer />
        <v-btn
          icon
          class="mt-n2 mr-n2"
          @click="showLocal = false"
        >
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        Please update your subscription in order to
        maintain access to your GCG Resources.
      </v-card-text>

      <v-card-actions
        class="justify-center pb-4"
      >
        <v-btn
          color="primary lighten-2"
          min-width="150"
          rounded
          @click="toggleUpdate"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  name: 'ErrorModal',

  mixins: [
    dialog,
  ],

  methods: {
    toggleUpdate() {
      window.open('https://globalcoachgroup.com/coaching-certification-fees/all-in-one-coaching-toolkit', '_blank');
      this.showLocal = false;
    },
  },
};
</script>
